import { Col, Form, Input, Row, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { useTranslation } from "react-i18next";
import { MONTHS } from "../../../../../constants/constants";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { ScenarioModel } from "../../../../../models/scenario.model";
import UTIL from "../../../../../utils/utils";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../atoms/icon";
import { AppChildrenSelect, AppSelect } from "../../../../atoms/select";

const { Option } = Select;


const InformationSection = (props: FormSectionProps<ScenarioModel>) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbShortName")}
                        name="short_name_for_scenario"
                        tooltip={{ title: t("Scenario.lbShortName"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("short_name_for_scenario", props.requiredFields)}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <Form.Item
                        className="lable-full-width"
                        label={t("Scenario.lbPlanningCycleEndDate")}
                        name="planing_cycle_end_date_month"
                        tooltip={{ title: t("Scenario.lbPlanningCycleEndDate"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("planing_cycle_end_date_month", props.requiredFields)}
                    >
                        <Select placeholder={t("Global.lbMonth")} >
                            {
                                MONTHS.map((item, index) => (
                                    <Option key={index} value={item.value}>{item.name}</Option>
                                ))
                            }
                        </Select>

                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="&nbsp;"
                        name="planing_cycle_end_date_year"
                        rules={VALIDATION_UTIL.getRulesValidationField("planing_cycle_end_date_year", props.requiredFields)}
                    >
                        <Select placeholder={t("Global.lbYear")} >
                            {
                                UTIL.planingCycleYears().map((item, index) => (
                                    <Option key={index} value={item}>{item}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
            </Row>



            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <AppSelect
                        placeholder={t("Global.plPleaseSelect")}
                        list={props.resources?.categories?.filter(p => p.level === 1)}
                        label={t("Scenario.lbBaselIILevel1Category")}
                        name="category_id"
                        tooltip={{ title: t("Scenario.ttBaselIILevel1Category"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("category_id", props.requiredFields)}
                    />
                </Col>
                <Col span={12}>

                    <AppChildrenSelect
                        parentName="category_id"
                        list={props.resources?.categories?.filter(p => p.level === 2)}
                        placeholder={t("Global.plPleaseSelect")}
                        listFilterName="parent_id"
                        label={t("Scenario.lbBaselIILevel2Category")}
                        name="category_level_2_id"
                        tooltip={{ title: t("Scenario.ttBaselIILevel2Category"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("category_level_2_id", props.requiredFields)}
                    />
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <AppChildrenSelect
                        parentName="category_id"
                        list={props.resources?.categories?.filter(p => p.level === 3)}
                        placeholder={t("Global.plPleaseSelect")}
                        listFilterName="parent_id"
                        label={t("Scenario.lbLevel2Detailed")}
                        name="category_level_3_id"
                        tooltip={{ title: t("Scenario.ttLevel2Detail"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("category_level_3_id", props.requiredFields)}
                    />
                </Col>

            </Row>



            <Row gutter={[16, 32]}>
                <Col span={24}>

                    <Form.Item
                        label={t("Scenario.lbDescriptionofEvent")}
                        name="description_of_event"
                        tooltip={{ title: t("Scenario.lbDescriptionofEvent"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("description_of_event", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("Scenario.plDescriptionofEvent")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <AppSelect
                        placeholder={t("Global.plPleaseSelect")}
                        list={props.resources?.failed_control_areas}
                        label={t("Scenario.lbLikelyFailed")}
                        name="likely_failed_control_area_id"
                        tooltip={{ title: t("Scenario.lbLikelyFailed"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("likely_failed_control_area_id", props.requiredFields)}
                    />
                </Col>

            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbDescriptionOfLikely")}
                        name="description_of_likely_control_failure"
                        tooltip={{ title: t("Scenario.lbDescriptionOfLikely"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("description_of_likely_control_failure", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("Scenario.plDescriptionOfLikely")} />
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default InformationSection;